import CopyButton, { type CopyButtonProps } from '../copy/button'

type CodeBlockCopyButtonProps = Omit<
	CopyButtonProps,
	'text' | 'isIconOnly' | 'size'
>

export default function CodeBlockCopyButton({
	targetToCopy,
	...rest
}: CodeBlockCopyButtonProps) {
	return (
		<CopyButton
			className="hds-code-block__copy-button"
			{...rest}
			text="Copy"
			isIconOnly
			size="small"
			targetToCopy={targetToCopy}
		/>
	)
}
